<template lang="pug">
  m-table(
    store-name="admintags"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockUserTags',
  components: { MTable },
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Show tag in documents',
          value: 'showInDocuments',
          valueFormatter: tag => (tag.showInDocuments ? this.$t('Yes') : this.$t('No')),
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'user.id': this.userId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
